<template>
  <fin-data-loader :resolver="fetchData" class="fin-screener-mask" fullpage>
    <template #loading_additional>
      <Portal to="breadcrumb_shareScreenerEdit">
        Lade...
      </Portal>
    </template>
    <template #content>
        <fin-screener-content :hasChanged="hasChanged"
                              :screener-type="'shareScreener'"
                              @applyTool="applyTool"
                              @reset="resetScreener"
                              v-if="selectedOption"
                              v-model="selectedOption"/>
    </template>
  </fin-data-loader>
</template>

<script>
import {finUserAPI} from '@/js/finAPI'
import FinScreenerContent from '@/components/pages/finTools/finScreener/screenerMask/content/index'
import {isEqual} from 'lodash-es'
import FinDataLoader from '@/components/common/DataLoader/index'

export default {
  name: 'fin-add-screener',
  components: {
    FinDataLoader,
    FinScreenerContent
  },
  data () {
    return {
      originalModel: undefined,
      selectedOption: undefined,
      filterOptions: undefined,
      selectedItems: [],
      displayMode: 'selection'
    }
  },
  methods: {
    setNewModel (newVal) {
      // clone the parameter into selectedOption
      if (newVal) {
        const newModel = JSON.parse(JSON.stringify(newVal))
        this.removeDuplicateFilterItems(newModel.filters)
        this.removeDuplicateFilterItems(newModel.valueFilters)
        this.selectedOption = newModel
      } else {
        console.error("Fehler beim Laden des Screeners this", this)
        this.$toasted.global.finToast({
          message: 'Dein Screener konnte nicht geladen werden.',
          type: 'error'
        })
      }
    },
    removeDuplicateFilterItems(filter){
      if (filter && filter.items && filter.items.length > 1) {
        for (let i = filter.items.length - 1; i > 0; i--) {
          // id is position identifier in position group
          // itemId is identifier of underlying field and might be used for multiple postion id !!
          const positionId = filter.items[i].item.id
          if (i > filter.items.findIndex((item) => {
            return item.item.id === positionId
          })) {
            console.error('removed duplicate for ', i, positionId)
            filter.items.splice(i, 1)
          }
        }
      }
    },
    resetScreener () {
      this.setNewModel(this.originalModel)
    },
    maxValue (item) {
      return Math.floor(this.capital / item.instrument.close)
    },
    applyTool () {
      this.$router.push({
        name: 'shareScreenerExecute',
        params: { id: this.$route.params.id }
      })
    },
    async fetchData () {
      this.filterOptions = []
      this.filterOptions.push(this.selectedOption)
      const userScreeners = await finUserAPI.getShareScreeners()
      console.log('fetchData user share screeners', userScreeners)
      userScreeners.forEach(item => {
        this.filterOptions.push(item)
      })
      this.originalModel = userScreeners.find(item => {
        return item.id === this.$route.params.id
      })
      console.log('fetchData this.originalModel', this.originalModel)
      this.setNewModel(this.originalModel)
    }
  },
  computed: {
    hasChanged () {
      const result = isEqual(this.originalModel, this.selectedOption)
      return !result
    },
  }
}

</script>

<style lang="scss" scoped>

  .fin-hasChanged {
    color: red;
    font-size: 20px;
    font-weight: bold;
    vertical-align: top;
  }

  ::v-deep .v-select__selections {
    font-weight: bold
  }

  ::v-deep .v-select__selections input {
    max-width: 10%
  }

  ::v-deep .v-input__slot {
    box-shadow: none !important;
  }

  ::v-deep .v-text-field > .v-input__control > .v-input__slot:after {
    border-style: none !important;
  }

  ::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none !important;
  }

  ::v-deep .fin-result-list-header .v-select__selection {
    color: $fin-color-primary-dark !important;
  }

</style>
